module.exports = __webpack_public_path__ + "static/JPEG image 163-dd1c812b4de483d9df5493f50daca94a.jpeg";